import actions from './actions'

const initialState = {
  agendas: {},
  currentAgenda: '',
  loading: true,
  speakers: {},
  speakersloading: true,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
